import React from "react";
import PropTypes from "prop-types";
import SectionsTitle from "../SectionTitle/SectionTitle";

const propTypes = {
  content: PropTypes.shape({}).isRequired,
};

const TableLayoutSection = ({ content }) => {
  return (
    <>
      <section className="table-layout-sec">
        <div className="container">
          <div className="text-center">
            <SectionsTitle
              title={content.table.title}
              subtitle={content.table.subTitle}
            />
          </div>
          <div className="list-items">
            <ul>
              {content.table.items.map((item,index) => {
                return (
                  <li key={index}>
                    <h3>{item.title}</h3>
                    <span>{item.label}</span>
                    <p>{item.description}</p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

const defaultProps = {};
TableLayoutSection.propTypes = propTypes;
TableLayoutSection.defaultProps = defaultProps;

export default TableLayoutSection;
